import axios from './themeInstance'
export default async (theme: any) => {
  const payload = {
    title: theme.title,
    theme: theme.theme,
  }

  try {
    const response: any = await axios.put(`/themes/${theme.id}`, payload)
    return response.data
  } catch (error) {
    return null
  }
}
